import { useShouldBeAuthenticated } from '@locaweb/lw-http-client'
import { authStore } from '@/store/auth'
import { httpClient } from '@/httpClient'
import { redirectUnauthenticatedUser } from './redirectUnauthenticatedUser'

const clientCenter = 'https://www.locaweb.com.br/criador-de-sites/'

export const [mustBeAuthenticated] = useShouldBeAuthenticated({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/api/v1`,
  authorizationCookieName: process.env.VUE_APP_COOKIE_NAME,
  tokenValidation: {
    resolveFunction: async () => {
      try {
        const { data: { data: user } } = await httpClient.get('/api/v1/user')
        const { login } = authStore()

        if (!user.product.active) {
          redirectUnauthenticatedUser(clientCenter)
        }

        login(user)
        return true
      } catch (error) {
        if (process.env.VUE_APP_COOKIE_NAME && error?.response?.status === 403) {
          redirectUnauthenticatedUser(clientCenter)
          return true
        }

        return false
      }
    }
  }
})
